<template lang="pug">
  v-divider(:style="dividerStyle" v-bind="$attrs" v-on="$listeners")
</template>

<script>
export default {
  name: 'YzDivider',
  props: {
    color: {
      type: String,
      default: 'yz-neutral-300'
    },
    width: {
      type: [String, Number],
      default: 1
    },
    height: {
      type: [String, Number],
      default: null
    }
  },
  computed: {
    dividerStyle() {
      const styles = {}

      // Handle width
      const width = typeof this.width === 'number' ? `${this.width}px` : this.width
      if (this.$attrs.vertical || this.$attrs.vertical === '') {
        styles.borderRightWidth = width
        styles.borderLeftWidth = 0
        styles.borderTopWidth = 0
        styles.borderBottomWidth = 0
      } else {
        styles.borderTopWidth = width
        styles.borderLeftWidth = 0
        styles.borderRightWidth = 0
        styles.borderBottomWidth = 0
      }

      // Handle height (only for vertical dividers)
      if (this.$attrs.vertical && this.height) {
        styles.height = typeof this.height === 'number' ? `${this.height}px` : this.height
      }

      // Handle color
      if (this.color && this.color.startsWith('#')) {
        // Hex color
        styles.borderColor = this.color
      } else if (this.color && this.color.startsWith('var(')) {
        // CSS variable
        styles.borderColor = this.color
      } else if (this.color) {
        // CSS class color - use CSS variable
        styles.borderColor = `var(--${this.color})`
      }
      
      return styles
    }
  }
}
</script>

<style lang="scss" scoped>
// Add any custom YzDivider styling here if needed
</style>